module.exports = __webpack_public_path__ + "static/media/benSignature.d4852ea7.png";